import { MdCallSplit } from "react-icons/md";
import { secondsToTime } from "../../../Components/Global";
import { useTranslation } from 'react-i18next';
import { ShowPopupWithoutButtons } from "../../../Components/Popup/Popup";
import { themeColor } from "../../..";
import { toast } from "react-toastify";
import Cfc from "../Cfc/Cfc";
import Spinner from "../../../Components/Spinner/Spinner";

let unique = -1;

function QueueStats(props:any) {
	const { t } = useTranslation();

	const cfc = () => {
		let checked: any;

		ShowPopupWithoutButtons(t('call_flow_control'),
			<Cfc/>,
			(r:any) => {
				if(r) {
					const status = false;
					if(checked.length !== 0) {
						if(status) {
							toast.success(t('agent_successfully_added'));
						} else {
							toast.error(t('unable_to_add_agents'));
						}
					}
				}
			},
			themeColor + ' ' + 'large'
		);
	}


	if(!props.queue) {
		return <div className="callout">
			<div className="queue-stats">
				<span className='spinner-container'>
					<Spinner />
				</span>
			</div>
		</div>
	}

	return <div className="callout">
		<div className="queue-stats">
			<div className="row">
				<div className="small-6 medium-6 large-6 columns">
					<b>{props.queue.name}</b>
				</div>
				<div className="small-6 medium-6 large-6 columns">
					<MdCallSplit
						className="cfc-icon"
						title={t('call_flow_control')}
						onClick={() => cfc()}
					/>
				</div>
			</div>
			<div className="row">
				<div className="small-12 medium-12 large-12 columns">
					<table className="unstriped">
						<thead>
							<tr key={unique--}>
								<th>
									<h4>{ props.queue.waiting }</h4>
								</th>
								<th>
									<h4>{ props.queue.completed}/{props.queue.total }</h4>
								</th>
								<th>
									<h4>{ props.queue.wait_avg == null ? "00:00" : secondsToTime(props.queue.wait_avg) }</h4>
								</th>
								<th>
									<h4>{ Math.round(props.queue.service_level * 100) + '%' }</h4>
								</th>
								<th>
									<h4>{ props.queue.member_available}/{props.queue.member_total }</h4>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr key={unique--}>
								<td>
									<b>{t('calls_in_queue')}</b>
								</td>
								<td>
									<b>{t('answered_calls')}</b>
								</td>
								<td>
									<b>{t('average_wait_time')}</b>
								</td>
								<td>
									<b>{t('service_level')}</b>
								</td>
								<td>
									<b>{t('agents_available')}</b>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
}

export default QueueStats;
